<template>
    <svg
        id="Capa_1"
        style="enable-background: new 0 0 442 442"
        version="1.1"
        viewBox="0 0 442 442"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0px"
    >
        <g>
            <path
                d="M364.401,40.381l-140.662-40c-0.056-0.016-0.113-0.021-0.169-0.036c-0.326-0.087-0.658-0.156-0.996-0.21
		c-0.109-0.017-0.218-0.036-0.328-0.05c-0.401-0.05-0.807-0.083-1.221-0.085C221.017,0.001,221.008,0,221,0
		c-0.425,0-0.841,0.035-1.252,0.087c-0.099,0.013-0.198,0.03-0.297,0.045c-0.357,0.056-0.708,0.129-1.052,0.222
		c-0.043,0.012-0.088,0.015-0.131,0.028l-0.223,0.063c-0.008,0.003-0.017,0.005-0.026,0.007L77.599,40.381
		C73.3,41.604,70.335,45.531,70.335,50v382c0,3.136,1.471,6.09,3.973,7.979c2.502,1.891,5.745,2.497,8.762,1.639l137.934-39.222
		l137.927,39.222c0.9,0.256,1.82,0.381,2.735,0.381c2.151,0,4.272-0.694,6.027-2.02c2.502-1.89,3.973-4.844,3.973-7.98V50
		C371.666,45.531,368.7,41.604,364.401,40.381z M90.335,57.553L211,23.241v361.207L90.335,418.76V57.553z M351.666,418.76
		L231,384.446V23.239l120.666,34.314V418.76z"
            />
            <path
                d="M258.267,80.994l60.662,17.25c0.915,0.26,1.835,0.384,2.74,0.384c4.356,0,8.363-2.869,9.614-7.267
		c1.511-5.313-1.571-10.843-6.883-12.354l-60.662-17.25c-5.313-1.51-10.843,1.572-12.354,6.883
		C249.873,73.952,252.955,79.483,258.267,80.994z"
            />
            <path
                d="M258.267,130.994l60.662,17.25c0.915,0.26,1.835,0.384,2.74,0.384c4.356,0,8.363-2.869,9.614-7.267
		c1.511-5.313-1.571-10.843-6.883-12.354l-60.662-17.25c-5.313-1.513-10.843,1.572-12.354,6.883
		C249.873,123.952,252.955,129.483,258.267,130.994z"
            />
            <path
                d="M258.267,180.994l60.662,17.25c0.915,0.26,1.835,0.384,2.74,0.384c4.356,0,8.363-2.869,9.614-7.267
		c1.511-5.313-1.571-10.843-6.883-12.354l-60.662-17.25c-5.313-1.512-10.843,1.572-12.354,6.883
		C249.873,173.952,252.955,179.483,258.267,180.994z"
            />
            <path
                d="M258.267,362.994l60.662,17.25c0.9,0.256,1.82,0.381,2.735,0.381c2.151,0,4.272-0.694,6.027-2.021
		c2.502-1.89,3.973-4.844,3.973-7.979v-132c0-4.469-2.966-8.396-7.265-9.619l-60.662-17.25c-3.016-0.857-6.26-0.251-8.762,1.639
		c-2.502,1.89-3.973,4.844-3.973,7.979v132C251.002,357.844,253.968,361.771,258.267,362.994z M271.002,234.615l40.662,11.563
		v111.207l-40.662-11.563V234.615z"
            />
            <path
                d="M178.267,343.755l-60.669,17.251c-5.312,1.511-8.394,7.042-6.883,12.354c1.25,4.398,5.257,7.267,9.614,7.267
		c0.905,0,1.826-0.124,2.74-0.384l60.669-17.251c5.312-1.511,8.394-7.042,6.883-12.354
		C189.11,345.327,183.578,342.245,178.267,343.755z"
            />
            <path
                d="M120.328,98.628c0.905,0,1.826-0.124,2.74-0.384l60.669-17.251c5.312-1.511,8.394-7.042,6.883-12.354
		c-1.51-5.312-7.043-8.394-12.354-6.883l-60.669,17.251c-5.312,1.511-8.394,7.042-6.883,12.354
		C111.965,95.759,115.971,98.628,120.328,98.628z"
            />
            <path
                d="M178.267,111.755l-60.669,17.251c-5.312,1.511-8.394,7.042-6.883,12.354c1.25,4.398,5.257,7.267,9.614,7.267
		c0.905,0,1.826-0.124,2.74-0.384l60.669-17.251c5.312-1.511,8.394-7.042,6.883-12.354
		C189.11,113.327,183.578,110.245,178.267,111.755z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Catalog",
};
</script>
